import { useEffect, useState } from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { getMetricas } from "../../services/adminService";
import StatCard from "../ui/StatCard";

// Painel inline de métricas no topo da AdminGuiasPage. Reaproveita o StatCard
// do Início pra manter a pegada visual. `refreshKey` muda a cada ação bem-
// sucedida na página pai → re-fetch das contagens. Métricas não são críticas:
// se o fetch falhar, o painel some em silêncio (a lista continua funcionando).
export default function AdminMetricasPanel({ refreshKey }) {
  const { C } = useTheme();
  const [m, setM] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    getMetricas()
      .then((data) => {
        if (active) {
          setM(data);
          setError(false);
        }
      })
      .catch(() => active && setError(true));
    return () => {
      active = false;
    };
  }, [refreshKey]);

  if (error || !m) return null;

  const cards = [
    { icon: "👥", label: "Total Geral", value: m.totalGeral, color: C.accent },
    { icon: "✅", label: "Ativos", value: m.totalAtivos, color: C.green },
    { icon: "⏸️", label: "Suspensos", value: m.totalSuspensos, color: C.red },
    { icon: "⏳", label: "Trial Expirado", value: m.totalTrialExpirados, color: C.purple },
    { icon: "🗑️", label: "Deletados", value: m.totalDeletados, color: C.textMuted },
    { icon: "🆕", label: "Novos (30d)", value: m.totalCriadosUltimos30Dias, color: C.blue },
  ];

  return (
    <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 24 }}>
      {cards.map((c) => (
        <StatCard key={c.label} icon={c.icon} label={c.label} value={c.value} color={c.color} />
      ))}
    </div>
  );
}
